<template lang="pug">
div.gallery.w-flex.column(
  :style="{width,height,backgroundColor}"
)
  h1.swiper-title.text-center {{header}}
  slot(name="sub")
  swiper.swiper.grow(
    :effect="'coverflow'" 
    :initialSlide="currentSlide"
    :grabCursor="true" 
    :centeredSlides="true" 
    :zoom="true"
    :slidesPerView="'auto'" 
    :threshold="10"
    :touchAngle="30"
    :coverflowEffect="{rotate: 50,stretch: 0,depth: 100,modifier: 1,slideShadows: true}"
    :navigation="true" 
    :pagination="{clickable: true}"
    @slideChange="currentSlide=$event.activeIndex"
  )
    swiper-slide.swiper-slide(
      v-for="item, index in items"
    )
      w-image(
        :src="item.src"
        width="100%"
        height="100%"
        :lazy="index>0"
      )
      h3.slide-title.text-center {{item.title}}
</template>

<script>

import { Swiper, SwiperSlide } from 'swiper/vue';
import SwiperCore, { Navigation, Pagination, EffectCoverflow } from 'swiper';
SwiperCore.use([Navigation, Pagination, EffectCoverflow]);
// Import Swiper styles
import 'swiper/swiper-bundle.css'

export default {
  name: 'Gallery',
  data() {
    return {
      currentSlide: 0,
    }
  },
  props: {
    items: {
      type: Array,
      required: true,
      note: 'List of gallery items'
    },
    backgroundColor: {
      type: String,
      required: false,
      default: "lightblue",
      note: 'CSS background-color'
    },
    header: {
      type: String,
      required: false,
      default: "",
      note: 'A title for the gallery'
    },
    width: {
      type: String,
      required: false,
      default: '100%',
      note: 'CSS width'
    },
    height: {
      type: String,
      required: false,
      default: '400px',
      note: 'CSS height'
    },
  },
  computed: {
    activeItem() {
      return this.items[this.currentSlide] || {}
    }
  },
  methods: {
    bla(swiper){
      console.log(swiper)
    }
  },
  components: {
    Swiper,
    SwiperSlide,
  },
  watch: {
    label() {
      this.labelField = this.label
    }
  }
}
</script>

<style lang="scss">
.swiper {
  width: 100%;
  height: 100%;
  padding-top: 20px;
  padding-bottom: 70px;
}

.swiper-title {
  padding: 10px;
}

.slide-title {
  padding: 10px;
}

.swiper-slide {
  background-position: center;
  background-size: cover;
  width: 400px;
  height: 100%;
}

.swiper-slide img {
  display: block;
  width: 100%;
}
</style>